import React from 'react';
import classNames from 'classnames';
import { FaCog } from 'react-icons/fa';
import Loading from 'components/Loading';
import { SIZE_ICON } from 'consts/data';
import { CommonIcons } from 'components/Icons';
import NewDesign from 'components/NewDesign';

const PaymentMethod = ({
  pack,
  isDefault,
  onRemove,
  onSetDefault,
  isSettingDefault,
  isActive,
  packageIsSetting,
}) => {
  const { brand, last4, id, metadata } = pack || {};
  const { phone } = metadata || {};

  const renderButtonDefault = () => {
    if (!isDefault) {
      if (!packageIsSetting) {
        return (
          <NewDesign.Button
            variant='text'
            onClick={onSetDefault(id, last4)}
            disabled={isSettingDefault}
          >
            <FaCog /> Set as default
          </NewDesign.Button>
        );
      }
      return (
        <button type='button' className='btn' style={{ boxShadow: 'none', outline: 0 }}>
          <Loading />
        </button>
      );
    }
    return null;
  };

  return (
    <div
      className={classNames('component:PaymentMethod each-payment', {
        active: isActive,
        'is-default': isDefault,
      })}
    >
      <div>
        <h5 className='payment-name'>
          {brand} - {phone}
        </h5>
        <h5 className='payment-code'>
          <p>* * * * * *</p>
          <p>{last4}</p>
        </h5>
      </div>
      <hr />
      <div className='payment-action'>
        {renderButtonDefault()}

        {/* Edit payment feature */}
        {/* <div
					onClick={(e) => {
						e.stopPropagation();
						console.log('click to child');
					}}
				>
					<FaEdit /> Edit
				</div> */}

        <NewDesign.Button
          outline
          color='danger'
          onClick={onRemove(id, last4)}
          disabled={isSettingDefault}
        >
          <CommonIcons.Trash size={SIZE_ICON} /> Remove
        </NewDesign.Button>
      </div>
    </div>
  );
};

PaymentMethod.defaultProps = {
  name: '',
  active: false,
  isDefault: false,
  isActive: false,
};

export default React.memo(PaymentMethod);
